import NextApp from './NextApp';

export default NextApp;
